import { useEffect, useState } from 'react';
import { Switch, Route } from 'react-router-dom';
import { Redirect } from 'react-router-dom';
import { experimentalStyled } from '@material-ui/core';
import DashboardNavbar from './DashboardNavbar';
import DashboardSidebar from './DashboardSidebar';

import Account from 'src/pages/admin/Account';
import CustomerList from 'src/pages/admin/CustomerList';
import Dashboard from 'src/pages/admin/Dashboard';
import ProductList from 'src/pages/admin/ProductList';
import Settings from 'src/pages/admin/Settings';


//Redux
import { useSelector, useDispatch } from "react-redux";
import {  logout } from '../../redux/actions/auth';

//My Components
import Calculator from 'src/pages/admin/Calculator';
import TestPage from 'src/pages/admin/testPage';
import BackD from 'src/testComponents/backdrop';
import AdminRoute from 'src/AdminRoutes'


const DashboardLayoutRoot = experimentalStyled('div')(
  ({ theme }) => ({
    backgroundColor: theme.palette.background.default,
    display: 'flex',
    height: '100%',
    overflow: 'hidden',
    width: '100%'
  })
);

const DashboardLayoutWrapper = experimentalStyled('div')(
  ({ theme }) => ({
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden',
    paddingTop: 64,
    [theme.breakpoints.up('lg')]: {
      paddingLeft: 256
    }
  })
);

const DashboardLayoutContainer = experimentalStyled('div')({
  display: 'flex',
  flex: '1 1 auto',
  overflow: 'hidden'
});

const DashboardLayoutContent = experimentalStyled('div')({
  flex: '1 1 auto',
  height: '100%',
  overflow: 'auto'
});

const DashboardLayout = () => {
  const dispatch = useDispatch();
  const [isMobileNavOpen, setMobileNavOpen] = useState(false);
  const { isLoggedIn} = useSelector((state) => state.auth);

  if (!isLoggedIn) {
      <Redirect to="/login" />;
  }


  return (
    <DashboardLayoutRoot>
      <DashboardNavbar onMobileNavOpen={() => setMobileNavOpen(true)} />
      <DashboardSidebar
        onMobileClose={() => setMobileNavOpen(false)}
        openMobile={isMobileNavOpen}
      />
      <DashboardLayoutWrapper>
        <DashboardLayoutContainer>
          <DashboardLayoutContent>

            <AdminRoute path="/admin/account" component={Account} />
            <AdminRoute path="/admin/customers" component={CustomerList} />
            <AdminRoute path="/admin/products" component={ProductList} />
            <AdminRoute path="/admin/settings" component={Settings} />
            <AdminRoute path="/admin/calculator" component={Calculator} />
            <AdminRoute path="/admin/testPage" component={TestPage} />
            {/* <AdminRoute path="/dashboard" component={Dashboard} /> */}
            {/* //TestAdminRoute */}
            <AdminRoute path="/admin/dashboard" component={Calculator} />

            {/* <Outlet /> */}
          </DashboardLayoutContent>
        </DashboardLayoutContainer>
      </DashboardLayoutWrapper>
    </DashboardLayoutRoot>
  );
};

export default DashboardLayout;
